<template>
  <div class="asset-item">
    <van-cell>
      <template #title>
        <span class="title">{{ safetypeName }}</span>
      </template>
      <template #right-icon>
        <van-icon name="arrow" size="18" v-if="safelink" @click="toPage()" />
      </template>
      <template #label>
        <van-row class="asset-data-info">
          <van-col :span="8">
            <span>{{ $t("assets.usenum") }}</span>
            <p>{{ isopen ? safeuseNum : "****" }}</p>
          </van-col>
          <van-col :span="8" class="txt-center" v-if="safefreezeNum">
            <span>{{ $t("assets.freeze") }}</span>
            <p>{{ isopen ? safefreezeNum : "****" }}</p>
          </van-col>
          <van-col :span="8" class="txt-right" v-if="safeconversion">
            <span>{{ $t("assets.convert") }}($)</span>
            <p>{{ isopen ? "$ " + safeconversion : "****" }}</p>
          </van-col>
        </van-row>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  name: "AssetItem",
  props: ["typeName",'typeId', "link", "useNum", "freezeNum", "conversion", "isopen"],
  computed: {
    safetypeId(){
      return this.typeId || 0
    },
    safetypeName() {
      return this.typeName || "";
    },
    safelink() {
      return this.link || "";
    },
    safeuseNum() {
      return this.useNum || "";
    },
    safefreezeNum() {
      return this.freezeNum || "";
    },
    safeconversion() {
      return this.conversion || "";
    },
    safeIsOpen() {
      return this.isopen || true;
    },
  },
  watch: {
    isopen: {
      handler(newVal, oldVal) {
        console.log(newVal + "," + oldVal);
      },
      deep: true,
    },
  },
  methods: {
    toPage() {
      this.$router.push(
        {
          name: "trade-account",
          query: {
            id: this.safelink,
            name: this.safetypeName,
            type: this.safetypeId,
            usd: this.safeuseNum,
            conversion: this.safeconversion
          },
        },
        () => {}
      );
    },
  },
};
</script>

<style>
</style>
